import Entity from "../entity";

export default class AuxiliaryService extends Entity<number> {
  name: string;
  isActive: boolean;


}
